var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrap"},[(_vm.$route.meta.mobileshow)?_c('meeting_head'):_vm._e(),_c('router-view'),(_vm.$route.meta.mobileshow)?_c('footer_index',{directives:[{name:"show",rawName:"v-show",value:(_vm.footShow),expression:"footShow"}]}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }